module.exports = __webpack_public_path__ + "static/img/_s-mc@2x.273beca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_s-mc@2x.png
// module id = 41iT
// module chunks = 0